function PushFeedback({ errors = [], message }) {
  if (!errors?.length && !message) {
    return null;
  }

  return (
    <div
      role={errors?.length ? "alert" : "status"}
      className={`mb-6 rounded border p-4 text-sm ${
        errors?.length
          ? "border-red-200 bg-red-50 text-red-700"
          : "border-blue-200 bg-blue-50 text-blue-700"
      }`}
    >
      {errors?.length ? (
        <ul className="list-disc space-y-1 pl-5">
          {errors.map((error) => (
            <li key={error}>{error}</li>
          ))}
        </ul>
      ) : (
        message
      )}
    </div>
  );
}

export default PushFeedback;
